import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CadastrarAdvogadoAvulsoDto } from '@/types/advogado/advogadoAvulsoTypes';

import { advogadoAvulsoService } from './services';

export const cadastrarAdvogadoAvulso = createAsyncThunk(
  'advogadoAvulso/cadastrar',
  async (data: CadastrarAdvogadoAvulsoDto, { rejectWithValue }) => {
    try {
      await advogadoAvulsoService.cadastrar(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
